import styled, { css } from 'styled-components'
// themes
import { colors } from 'themes/index'
// components
import Grid from '@mui/material/Grid2'
// views
import { BottomPaper as BottomPaperOrigin } from 'themes/views/settings'
// utils
import { size } from 'polished'

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-left: 16px;
  outline: none;
  background-size: contain;
  border-radius: 4px;
`

export const AvatarOverlay = styled.div<{ avatar?: string }>`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${colors.purple400};
  text-align: center;
  border: 2px solid ${colors.purple400};
  border-radius: 4px;
  left: 40px;
  right: 0;
  top: 0;
  bottom: 0;
  padding: 10px;
  cursor: pointer;
  background-color: ${colors.gray280};
  ${size('200px')};

  ${({ avatar }) =>
    avatar &&
    css`
      background: url(${avatar}) round;

      > * {
        display: none;
      }

      &:hover {
        > * {
          display: initial;
        }
      }
    `};
`

export const TopSection = styled.div`
  display: flex;

  > div {
    flex: 1;
  }
`

export const TopSectionFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const BottomSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 16px;
`

export const PhonesSection = styled.div`
  display: flex;
  gap: 16px;
  grid-column: span 2;
`

export const FormInnerWrapper = styled.div`
  margin: 20px 16px 64px 16px;
`

export const BottomPaper = styled((props) => <BottomPaperOrigin {...props} />)`
  && {
    margin: 0;
    position: fixed;
    bottom: 0;
    right: 0;
    width: calc(100% - 72px);
  }
`

export const FieldsContainer = styled((props) => <Grid {...props} />)`
  && {
    > div {
      margin-bottom: 8px;
    }
  }
`

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  .MuiAccordionSummary-content {
    font-size: 16px;
  }
`
